import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.scss']
})
export class ImageDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ImageDialogComponent>) { }

  ngOnInit() { }

  public uploadPhoto() {
    this.dialogRef.close('upload');
  }
  public deletePhoto() {
    this.dialogRef.close('delete');
  }
}
